const { createDate, vehicleReqDate, routeShortForm, routeDetails } = require('../../utils');

module.exports = [{
  title: 'Indent ID',
  tlabel: 'INDENT_INDENT_ID',
  label: 'order_no',
  colSpan: 3,
  data: {
    key: 'order_no',
  },
  truncate_on: 20,
  dependency: {
    is_enabled: true,
    data: {
      key: 'created_at',
      view_rule: date => createDate(date),
    },
    truncate_on: 20,
  },
},
{
  title: 'Status',
  tlabel: 'INDENT_STATUS',
  label: 'status',
  colSpan: 3,
  data: {
    key: 'status',
  },
  truncate_on: 20,
},
{
  title: 'Route',
  tlabel: 'INDENT_ROUTE',
  label: 'route',
  colSpan: 4,
  tooltip: true,
  data: {
    key: 'route',
    view_rule: routeLocation => routeShortForm(routeLocation),
  },
  expanded_text: {
    data: {
      key: 'route',
      view_rule: routeLocation => routeDetails(routeLocation),
    },
    truncate_on: 20,
  },
  truncate_on: 20,
},
{
  title: 'Vehicle & Date',
  tlabel: 'INDENT_VEHICLE_AND_DATE',
  label: 'vehicle_type',
  colSpan: 4,
  data: {
    key: 'vehicle_type',
  },
  truncate_on: 20,
  dependency: {
    is_enabled: true,
    data: {
      key: 'vechile_req_date',
      view_rule: date => vehicleReqDate(date),
    },
    truncate_on: 20,
  },
}];
